import React from "react";
import IconButton from "@vapor/react-material/IconButton";
import AngleUp from "@vapor/react-icons/AngleUp";
import AngleDown from "@vapor/react-icons/AngleDown";
import Collapse from "@vapor/react-material/Collapse";
import Box from "@vapor/react-material/Box";
import TableRow from "@vapor/react-material/TableRow";
import TableCell from "@vapor/react-material/TableCell";
import Product from "./Product.tsx";
import { ItemProps } from "../types.ts";

const InvoicesProducts = ({ row }: { row: ItemProps }) => {
  const [open, setOpen] = React.useState<boolean>(false);



  
  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <AngleUp /> : <AngleDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right">{row.date}</TableCell>
        <TableCell align="right">{row.customer}</TableCell>
        <TableCell align="right">{row.total_amount} $</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
          borderBottom={false}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {row.products.map((product, index) => {
                return <Product product={product} key={index} />;
              })}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default InvoicesProducts;
